class ReviewsSlider {
  constructor(container) {
    this.container = container;
    this.section = container.closest(".reviews-slider");
    this.swiperInstance = null;

    this.init();
  }

  init() {
    this.animateStars();

    if (typeof Swiper === "undefined") {
      this.loadSwiper().then(() => {
        this.initializeSwiper();
      });
    } else {
      this.initializeSwiper();
    }
  }

  animateStars() {
    const starsContainer = this.section.querySelector("[data-stars-animate]");
    if (!starsContainer || !window.WStarsAnimation) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            WStarsAnimation.animate(starsContainer);
            observer.unobserve(starsContainer);
          }
        });
      },
      { threshold: 0.1 },
    );

    observer.observe(starsContainer);
  }

  loadSwiper() {
    return new Promise((resolve, reject) => {
      if (!document.querySelector("[data-swiper-css]")) {
        const swiperCSS = document.createElement("link");
        swiperCSS.rel = "stylesheet";
        swiperCSS.href =
          "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        swiperCSS.dataset.swiperCss = "";
        document.head.appendChild(swiperCSS);
      }

      if (!document.querySelector("[data-swiper-js]")) {
        const swiperJS = document.createElement("script");
        swiperJS.src =
          "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
        swiperJS.dataset.swiperJs = "";
        swiperJS.onload = () => resolve();
        swiperJS.onerror = () => reject(new Error("Failed to load Swiper"));
        document.head.appendChild(swiperJS);
      } else {
        const checkSwiper = setInterval(() => {
          if (typeof Swiper !== "undefined") {
            clearInterval(checkSwiper);
            resolve();
          }
        }, 50);
      }
    });
  }

  getSettings() {
    return {
      slidesPerViewDesktop: parseFloat(
        this.container.dataset.slidesDesktop || "3",
      ),
      slidesPerViewMobile: parseFloat(
        this.container.dataset.slidesMobile || "1",
      ),
      spaceBetweenDesktop: parseInt(
        this.container.dataset.spaceDesktop || "18",
        10,
      ),
      spaceBetweenMobile: parseInt(
        this.container.dataset.spaceMobile || "18",
        10,
      ),
      autoplayEnabled: this.container.dataset.autoplay === "true",
      autoplayDelay: parseInt(
        this.container.dataset.autoplayDelay || "5000",
        10,
      ),
    };
  }

  initializeSwiper() {
    const settings = this.getSettings();
    const prevButton = this.section.querySelector(
      ".reviews-slider__arrow--prev",
    );
    const nextButton = this.section.querySelector(
      ".reviews-slider__arrow--next",
    );
    const pagination = this.section.querySelector(
      ".reviews-slider__pagination",
    );

    const swiperConfig = {
      slidesPerView: "auto",
      spaceBetween: settings.spaceBetweenMobile,
      centeredSlides: true,
      loop: false,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      initialSlide: 1,
      breakpoints: {
        990: {
          spaceBetween: settings.spaceBetweenDesktop,
          centeredSlides: false,
          initialSlide: 0,
        },
      },
      on: {
        init: () => {
          this.container.classList.add("swiper-initialized");
          this.updateNavigationState(this.swiperInstance);
        },
        slideChange: (swiper) => {
          this.updateNavigationState(swiper);
        },
      },
    };

    if (prevButton && nextButton) {
      swiperConfig.navigation = {
        prevEl: prevButton,
        nextEl: nextButton,
      };
    }

    if (pagination) {
      swiperConfig.pagination = {
        el: pagination,
        clickable: true,
      };
    }

    if (settings.autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: settings.autoplayDelay,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      };
    }

    this.swiperInstance = new Swiper(this.container, swiperConfig);
  }

  updateNavigationState(swiper) {
    if (!swiper) return;

    const prevButton = this.section.querySelector(
      ".reviews-slider__arrow--prev",
    );
    const nextButton = this.section.querySelector(
      ".reviews-slider__arrow--next",
    );

    if (!prevButton || !nextButton) return;

    if (swiper.isBeginning) {
      prevButton.setAttribute("disabled", "disabled");
    } else {
      prevButton.removeAttribute("disabled");
    }

    if (swiper.isEnd) {
      nextButton.setAttribute("disabled", "disabled");
    } else {
      nextButton.removeAttribute("disabled");
    }
  }

  destroy() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

function initReviewsSliders() {
  const sliders = document.querySelectorAll("[data-reviews-slider]");

  sliders.forEach((slider) => {
    if (!slider.dataset.initialized) {
      new ReviewsSlider(slider);
      slider.dataset.initialized = "true";
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initReviewsSliders);
} else {
  initReviewsSliders();
}

document.addEventListener("shopify:section:load", (event) => {
  const slider = event.target.querySelector("[data-reviews-slider]");
  if (slider) {
    delete slider.dataset.initialized;
    new ReviewsSlider(slider);
    slider.dataset.initialized = "true";
  }
});

document.addEventListener("shopify:section:unload", (event) => {
  const slider = event.target.querySelector("[data-reviews-slider]");
  if (slider && slider.swiper) {
    slider.swiper.destroy(true, true);
    delete slider.dataset.initialized;
  }
});
